import { Category } from "@mui/icons-material";

const locale = {
  contracted_projects: "Contracted Projects",
  other_products: "Other Products",
  search_projects: "Search projects/tags",
  select_an_option: "Select an option",
  no_tags_available: "No tags available",
  tag_not_found: "Tag not found",
  select_a_tag: "Select a tag",
  select_an_aoi: "Select an AOI",
  aoi_not_found: "AOI not found",
  no_aois_available: " No AOIs available",
  most_used_tags: "Most used tags",
  add_tag: "Add tag",
  delete_tag: "Delete tag",
  add_aoi: "Add AOI",
  delete_aoi: "Delete AOI",
  search: "Search",
  header_title: "Asbestos: Census and Removal Schedule",
  txt_footer_privacity: "Privacy Policy and Cookies",
  txt_footer_legal: "Legal Notice",
  txt_description:
    "Municipalities are required to conduct a census of facilities and sites containing asbestos, including a schedule for its removal, in accordance with Law 07/2022, of April 8, on waste and contaminated soils for a circular economy. Comply with Law 07/2022 easily with our solution.\nAgforest provides a complete solution for your asbestos facility census, using artificial intelligence algorithms and satellite imagery to detect asbestos in your locality.",
  txt_description_title:
    "Census of Facilities with Asbestos Presence in Municipalities - Mandatory under Law 07/2022",
  txt_description_title_information:
    "In this tool, you can obtain a quote for asbestos remote sensing services for municipalities, as well as analyses that will help you understand and provide relevant information for your client.",
  log_in: "Login",
  password: "Password",
  user_name: "User name",
  do_you_want_to_know_more: "Do you want to know more?",
  contact_us: "Contact us",
  solutions: "Solutions",
  asbestos_census: "Asbestos census",
  water_leaks: "Water leaks",
  co2_sinks: "CO2 sinks",
  esg_transformation: "ESG transformation",
  about_agforest: "About AGForest",
  blog: "Blog",
  press_room: "Press room",
  success_stories: "Success stories",
  about_us: "About us",
  contact: "Contact",
  innovative_sme: "Innovative SME",
  valid_until: "Valid until May 24, 2027",
  privacyand_cookie_policy: "Privacy and cookie policy",
  legal_notice: "Legal notice",
  spain: "Spain",
  solutions: "Solutions",
  about_us: "About Us",
  press_room: "Press Room",
  blog: "Blog",
  success_cases: "Success Cases",
  contact_us: "Contact Us",
  asbestos_census: "Asbestos Census",
  water_leaks: "Water Leaks",
  co2_sinks: "CO2 Sinks",
  esg_transformation: "ESG Transformation",
  log_out: "Log out",
  visit: "Visit",
  tags: "Tags",
  aois: "AOIs",
  image: "Image",
  category: "Category",
  description: "Description",
  title: "Title",
  grid_view: "Grid view",
  list_view: "List view",
};
export default locale;
